import React from 'react';
import InjectStore from '../../common/utils/InjectStore';
import { Tooltip } from '@material-ui/core';
import { Typography, Switch, Box, Grid, Button } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from "@material-ui/icons/Edit"
import { observable } from 'mobx';
import ParserErrorsDialog from '../layouts/ParserErrorsDialog';
class ParserSummary extends React.Component {
  state = observable({
    parserErrorsDialog: {
      open: false,
      values: [],
      templateId: ""
    },
  })

  handleNext = () => {
    this.props.store.showMapFieldsDialog();
  }

  handleShowParserErrorsDialog = (key) => {
    this.state.parserErrorsDialog.values = this.props.store.currentData.templates[key].errors_composed || [];
    this.state.parserErrorsDialog.open = true
    this.state.parserErrorsDialog.templateId = key;
  }

  handleCloseParserErrorsDialog = () => {
    this.state.parserErrorsDialog.values = [];
    this.state.parserErrorsDialog.open = false;
  } 

  handleClearErrors = (key) => {
    Ext.Msg.confirm('Alert', 'Are you sure?', (button) => {
      if (button === 'yes') {
        this.props.store.handleClearErrors(key);
        this.handleCloseParserErrorsDialog();
      }
    });
  }

  render () {
    const me = this,
      { store } = me.props;

    return (
      <Grid container >
        {
          store.currentData.templates.map((template, key) => {
            return (
              <Grid
                item
                container xs={12}
                direction="column"
                key={key}
              >
                {/* Parser {key + 1} */}
                <Typography variant="h6">Parser {key + 1}</Typography>
                <Typography
                  style={{ padding: 3 }}
                  variant="body1">
                  Map
                  </Typography>
                <Grid
                  item
                  container
                  direction="row"
                  justify="space-between"
                  alignItems="center"
                >
                  <Grid
                    item
                    container
                    direction="column"
                    // xs={5}
                    xs
                    style={{
                      padding: 5,
                      cursor: "pointer"
                    }}
                    onClick={store.handleEditTemplate.bind(store, key)}
                  >
                    {
                      template.fields.map((field, key) =>
                        <Typography
                          variant="body2"
                          key={key}>
                          "{field.column ? field.column.name : ""}" to {field.value ? field.value.name : ""}
                        </Typography>
                      )
                    }
                  </Grid>
                  <Grid
                    item
                    container
                    direction="column"
                    // xs={7}
                    xs
                  // style={{ padding: 5 }}
                  >
                    <Box
                      variant="body2"
                      fontStyle="italic"
                      key={key}
                      align="right"
                    >
                      {
                        template.criteria_type != 2
                        &&
                        (typeof template.criteria == "object"
                          ? template.criteria.query_string
                          : template.criteria)
                      }
                    </Box>
                    <Grid
                      item
                      container
                      direction="row"
                      justify="flex-end"
                      alignItems="center"
                    >
                      { store.currentData.templates[key].errors &&
                        store.currentData.templates[key].errors.length > 0 && 
                        <Button variant="contained" color="primary" onClick={me.handleShowParserErrorsDialog.bind(me, key)}>
                          Errors 
                        </Button>  
                      }
                      <Button variant="contained" color="primary" onClick={() => store.handleTestParserButtonClick(key)}>
                        Test Parser
                      </Button>
                      <Tooltip title={!template.is_disabled ? "Pause parser" : "Make parser active"}>
                        <Switch
                          checked={!template.is_disabled}
                          onChange={(ev) => {
                            store.disableTemplate(!ev.target.checked, key)
                          }}
                        ></Switch>
                      </Tooltip>
                      <EditIcon
                        className="menu_button_inside"
                        aria-haspopup="true"
                        onClick={store.handleEditTemplate.bind(store, key)}
                      />
                      <DeleteIcon
                        className="menu_button_inside"
                        aria-haspopup="true"
                        onClick={store.handleDeleteTemplate.bind(store, key)}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            );
          })
        }
        <ParserErrorsDialog {...this.state.parserErrorsDialog} 
                        onClearErrors={this.handleClearErrors}
                        onClose={me.handleCloseParserErrorsDialog} />
      </Grid >
    );
  }

}

export default InjectStore(ParserSummary);
